import { Actor } from "../actors/Actor";
import { Effect } from "./Effect";
import { Target, TargetOptions } from "./Target";

export class Ability {
  advancesTurn: boolean;
  target: Target | undefined;
  effects: Effect[] | undefined;

  constructor(public name: string, data: any) {
    this.advancesTurn = !!data.advancesTurn;
    this.target = new Target(data.target);
    this.effects = data.effects?.map((e: any) => new Effect(e));
  }

  apply(actor: Actor, targetOptions: TargetOptions) {
    this.effects?.forEach((e) => e.apply(actor, targetOptions));
  }
}
